import PicklistMetadata from "../PicklistMetadata";

// Static picklist of business-term categories, sourced from the loaded pick values whose
// Type is "Category Term Type" (display = Name, value = Value). The discriminator lives in
// PICK_TYPE (→ session "Type" field), matching the Data Protection Classification convention;
// PlatformSelect's static branch keeps rows where pickInstance[typeField] === typeValue.
class CategoryTermTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "CategoryTermType";
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Category Term Type";
        this.useRealm = false;
        this.allowNoSelection = false;
    }
}

export default CategoryTermTypePicklistMetadata;
